import React from "react";

import { OperationType } from "../../stores/OperationTypeEnum";
import { RegisterForm } from "../RegisterForm";

export const UpdateUserData: React.FC = () => {
	return (
		<div>
			<RegisterForm pageType={OperationType.Update} />
		</div>
	);
};
